import React from 'react';
import SmallGalleryComponent from '../galleries/SmallGalleryComponent';
import CallToActionOne from '../cta/CallToActionOne';
import SmallGalleryDominationComponent from '../galleries/SmallGalleryDominationComponent';
// Components

function DominationServicesPageMainContainer() {
  return (
    <main role='main' className='grid gap-y-12 w-full h-full pb-12'>
      <section className='grid w-full'>
        <div className='grid w-full px-6 lg:container lg:mx-auto gap-8 pt-12'>
          <ul className='grid gap-4 text-center pl-6'>
            <li>
              <strong>Verbal Humiliation & Mind Games:</strong> Cold, calculated
              words that strip you down mentally and emotionally.
            </li>
            <li>
              <strong>Spanking, Slapping & Impact Play:</strong> From soft to
              severe—my hand or my tools will train your body to obey.
            </li>
            <li>
              <strong>Chastity Control & Keyholding:</strong> Denied, locked,
              teased. Your pleasure belongs to me now.
            </li>
            <li>
              <strong>CBT (Cock and Ball Torture):</strong> Pain, pressure, and
              punishment delivered precisely where it hurts most.
            </li>
            <li>
              <strong>Sissification & Role Reversal:</strong> Feminized,
              humiliated, and trained into obedient softness—my perfect doll.
            </li>
            <li>
              <strong>Foot Worship & Trampling:</strong> At my feet, under my
              heel—your proper place.
            </li>
          </ul>

          <ul className='grid gap-4 text-center pl-6 mt-12'>
            <li>
              <strong>Sissy training / Maid training</strong>
            </li>
            <li>
              <strong>Slave & submissive training</strong>
            </li>
            <li>
              <strong>Corporal punishment (canes, whips, paddles)</strong>
            </li>
            <li>
              <strong>Bondage & humiliation</strong>
            </li>
            <li>
              <strong>Discreet abduction scenarios</strong>
            </li>
            <li>
              <strong>Dining/afternoon tea experiences</strong>
            </li>
            <li>
              <strong>Segufix restraint play</strong>
            </li>
            <li>
              <strong>Some medical play</strong>
            </li>
            <li>
              <strong>Double domme sessions</strong> (advance notice required)
            </li>
            <li>
              <strong>Pegging / Strap-on</strong>
            </li>
            <li>
              <strong>
                Transformations, crossdressing / sissy play (with outfits and
                shoes)
              </strong>
            </li>
            <li>
              <strong>Video work</strong>
            </li>
          </ul>
          <p className='text-center text-lg italic text-colour6 pt-4'>
            If something you desire is not listed—<strong>just ask</strong>.
          </p>
        </div>
      </section>

      {/* Cta */}
      <CallToActionOne />

      {/* Form section */}
      <section className='grid w-full'>
        <div className='grid w-full px-6 lg:container lg:mx-auto gap-8 pt-12'>
          <SmallGalleryDominationComponent />
        </div>
      </section>
    </main>
  );
}

export default DominationServicesPageMainContainer;
